import { useState, useCallback, useRef } from 'react';

export const useCanvaPopover = () => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  // Close on escape or click outside is handled by the CanvaPopover component
  return {
    isOpen,
    triggerRef,
    open,
    close,
    toggle
  };
}; 